import React from 'react';
import PropTypes from 'prop-types';

const NumberOne = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="8.98"
    height="14.2"
    viewBox="0 0 8.98 14.2"
    className={className}
  >
    <path
      d="M-4.05,0H4.69V-2.22H1.63V-14.2H-.73l-3.56,3.42,1.52,1.6,1.14-1.08a3.244,3.244,0,0,0,.62-.8h.04s-.02.48-.02.96v7.88H-4.05Z"
      transform="translate(4.29 14.2)"
      fill={fill}
    />
  </svg>
);

NumberOne.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default NumberOne;
